export enum SendingType {
    SendToLastMessenger = 1,
    SendToAllMessengers,
    SendCascade
}